module.exports = __webpack_public_path__ + "static/media/hero-van.c35ebf28.png";